import logoMain from '@/assets/logo-main.svg'
import loginIcon from '@/assets/login-icon.svg'
import createAccount from '@/assets/createaccount-icon.svg'
import heroBannerImage from '@/assets/herobanner-image.jpg'
import heroPhoneImage from '@/assets/herophone-image.png'
import playButton from '@/assets/play1-icon.svg'
import plusIcon from '@/assets/plus-icon.svg'
import manStrike from '@/assets/manstrike-image.png'
import topOne from '@/assets/1st-image.png'
import topTwo from '@/assets/2nd-image.png'
import topThree from '@/assets/3rd-image.png'
import playerOne from '@/assets/pic1-image.png'
import playerTwo from '@/assets/pic2-image.png'
import playerThree from '@/assets/pic3-image.png'
import totalPoints from '@/assets/totalpoint-svg.svg'
import manBlock from '@/assets/manblock-image.png'
import logoFooter from '@/assets/logo-footer.svg'
import facebookIcon from '@/assets/facebook-icon.svg'
import linkedInIcon from '@/assets/linkedin-icon.svg'
import twitterIcon from '@/assets/twitter-icon.svg'
import paulRaudkepp from '@/assets/first-place.jpg'
import ianMarshall from '@/assets/second-place.jpg'
import profileAvatar from '@/assets/Tony.jpeg'
import logoMainMobile from '@/assets/logo-main-mobile.svg'
import heroPhoneImageMobile from '@/assets/herophone-mobileimage.png'
import sampleScoring from '@/assets/sample-score-2.png'
import manBlockMobile from '@/assets/manblock-imagemobile.png'
import instagramIcon from '@/assets/instagram-icon.svg'
import theLongBall from '@/assets/3.jpg'
import dashBoard from '@/assets/1.jpg'
import scoring from '@/assets/2.jpg'

import Player from '@vimeo/player'
import SimpleGDPR from 'simple-gdpr'
import 'simple-gdpr/dist/simplegdpr.min.css'

import MainButton from '@/components/MainButton/index'

export default {
  name: 'landing-page',
  data: () => ({
    scoring,
    dashBoard,
    theLongBall,
    loginIcon,
    createAccount,
    heroBannerImage,
    logoMain,
    heroPhoneImage,
    playButton,
    dialog: false,
    dialog1: false,
    dialog2: false,
    plusIcon,
    manStrike,
    topOne,
    topTwo,
    topThree,
    playerOne,
    playerTwo,
    playerThree,
    totalPoints,
    manBlock,
    logoFooter,
    facebookIcon,
    linkedInIcon,
    twitterIcon,
    paulRaudkepp,
    ianMarshall,
    profileAvatar,
    logoMainMobile,
    heroPhoneImageMobile,
    sampleScoring,
    manBlockMobile,
    instagramIcon
  }),
  components: {
    MainButton
  },
  mounted() {
    var logo = document.getElementById('logo-mobile')
    logo.style.display = 'none'

    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('load', () => {
      if (!document.cookie.includes('simple-gdpr')) {
        const group = document.createElement('div')
        const message = document.createElement('span')

        message.innerText =
          'We use browser cookies to personalize content and Ads, to provide social media features and analyse traffic.'

        group.appendChild(message)

        const notice = new SimpleGDPR({
          theme: 'dark',
          animation: 'slide',
          float: 'bottom-right',
          message: group,
          callback: () => {
            document.cookie = 'simple-gdpr'
            notice.close()
          }
        })
      }
    })
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },

  methods: {
    onScroll() {
      var navbar = document.getElementById('navbar')
      var logo = document.getElementById('logo-mobile')

      if (window.scrollY == 0) {
        logo.style.display = 'none'
        navbar.classList.remove('sticky')
      } else {
        logo.style.display = 'block'
        navbar.classList.add('sticky')
      }
    },
    pause: function(event) {
      var id = event.target.getAttribute('data-id')
      var iframe = document.getElementById(id)
      var player = new Player(iframe)
      player.pause()
    }
  }
}
